import React from "react";
import styled, { css, useTheme } from "styled-components";
import PropTypes from "prop-types";
import LegacyIcon from "components/icons/legacy-icon";

const HighlightList = styled.div`
  margin: 0;
  padding: 0;
  ${({ isProfile }) => isProfile ?
    css`
      display: grid;
      grid-template-columns: max-content max-content;
      row-gap: 1.438rem;
      column-gap: 2.438rem;
    `:
    css`
      display: flex;
      flex-direction: row;
      column-gap: 0.625rem;
      align-content: flex-start;
      flex-wrap: wrap;
    `
  };
`;

const HighlightCardItem = styled.div`
  ${({ isProfile }) => isProfile ?
  css`
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    padding: 0;
    margin: 0 0 .25rem;
    flex: 50%;
    width: 100%;
    
    :last-of-type {
      margin: 0;
    }
  ` :
  css`
    list-style-type: none;
    margin: 0 0 1.5rem;
    padding: 0;
  
    :last-of-type {
      margin: 0;
    }
  `
  }
`;

const HighlightText = styled.span`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  font-size: 0.875rem;
  font-weight: ${({ isProfile }) => isProfile ? '600' : '500'};
  line-height: 1.063rem;
  padding: ${({ isProfile }) => isProfile? '0' :  '0px 0.25rem'};
`;

function Highlight({ item, isProfile }) {
  const theme = useTheme();
  const { attributes } = item;
  const { icon, title, category } = attributes;
  const isCostCategory = category.toLowerCase() === "cost";
  const hideTitle = isCostCategory && title?.match(/expensive/i) && !isProfile;
  const iconTitle = isCostCategory ? "Pricing" : title;

  let height = 16;
  let width = parseInt(icon?.match(/-([0-9]*)x/)?.[1], 10) || height;
  if (isProfile) {
    height *= 2;
    width *= 2;
  }

  return (
    <HighlightCardItem isProfile={isProfile} key={title}>
      {icon && (
        <LegacyIcon
          name={`${icon}-20`}
          color={theme.colors.orange}
          width={width}
          height={height}
        />
      )}
      {title && !hideTitle && <HighlightText isProfile={isProfile}>{iconTitle}</HighlightText>}
    </HighlightCardItem>
  );
}

Highlight.propTypes = {
  item: PropTypes.shape({
    attributes: PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string,
      category: PropTypes.string,
    }),
  }),
  isProfile: PropTypes.bool,
};

Highlight.defaultProps = {
  isProfile: true,
  item: {
    attributes: {},
  },
};

function Highlights({ data, isProfile, className, length }) {
  return (
    <HighlightList className={className} isProfile={isProfile}>
      {data &&
        data
          .slice(0, length)
          .map((item) => <Highlight key={item?.attributes?.title} item={item} isProfile={isProfile} />)}
    </HighlightList>
  );
}

export default Highlights;

Highlights.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  isProfile: PropTypes.bool,
  className: PropTypes.string,
  length: PropTypes.number,
};

Highlights.defaultProps = {
  data: [],
  isProfile: true,
  className: "",
  length: 4,
};
